import { render, staticRenderFns } from "./FormResign.vue?vue&type=template&id=417484e0&"
import script from "./FormResign.vue?vue&type=script&lang=js&"
export * from "./FormResign.vue?vue&type=script&lang=js&"
import style0 from "./FormResign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports